
export default {
  props: {
    trackClass: {
      type: String,
      default: '',
    },
    centerItems: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selector: {},
    }
  },
  mounted() {
    // scope to parent component
    this.selector = this.$gsap.utils.selector(this.$parent.$el)

    this.$nextTick(() => {
      this.initSlider()
      window.addEventListener('resize', this.initSlider)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initSlider)
  },
  methods: {
    initSlider() {
      // grab parent (container) width to calculate dimensions/positioning
      const containerWidth = this.$el.clientWidth

      if (!containerWidth) return

      // calculate and set css slider positioning
      this.$gsap.set(this.selector('.slider__track'), {
        paddingLeft: `calc(calc(100vw - ${containerWidth}px) / 2)`,
        // marginLeft: `calc(calc(100vw / 2 - ${containerWidth}px / 2) * -1)`,
        // width: '100vw',
      })
      this.$gsap.set(this.selector('.slider__item'), {
        flex: 'none',
      })

      // create draggable
      this.$Draggable.create(this.selector('.slider__track'), {
        type: 'scrollLeft',
        edgeResistance: 1,
        maxDuration: 1.2,
        minDuration: 1.2,
        lockAxis: true,
        throwProps: true,
        allowContextMenu: true,
        inertia: true,
        snap(e) {
          return -Math.round(
            Math.round(e / (0.3 * containerWidth)) * (0.3 * containerWidth)
          )
        },
      })
    },
  },
}
